import React, { useRef } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts"; // Assuming you have other charts

import ChartAction from "./ChartAction";
import { useLanguageContext } from "../../../Context/LanguageContext";
export default function DynamicChartContainer({
  heading,
  rows,
  onExport,
  chartType = "Bar",
  keyOfChart,
  equipmentGroupList,
  selectedEquipmentGroupId,
  setSelectedEquipmentGroupId,
}) {
  const inspectionKpiRef = useRef("");
  const equipmentKpiRef = useRef("");
  const ticketKpiRef = useRef("");
  const OrgKpiRef = useRef("");
  const { localization } = useLanguageContext();

  return (
    <Box
      style={{ border: "1px solid #DADADA" }}
      ref={
        keyOfChart === "EquiStatusDistribution"
          ? equipmentKpiRef
          : keyOfChart === "InspectionKpi"
          ? inspectionKpiRef
          : keyOfChart === "TicketKpi"
          ? ticketKpiRef
          : OrgKpiRef
      }
      id={
        keyOfChart === "EquiStatusDistribution"
          ? "equipmentKpiRef"
          : keyOfChart === "InspectionKpi"
          ? "inspectionKpiRef"
          : keyOfChart === "TicketKpi"
          ? "ticketKpiRef"
          : "OrgKpiRef"
      }
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          marginBottom: 2,
          borderBottom: "1px solid #DADADA",
          paddingTop: "8px",
        }}
        id="chartHeaderBarRef"
      >
        {/* Heading on the left */}
        <Typography variant="h5" paddingLeft={2} fontWeight={600}>
          {heading}
        </Typography>

        {/* Buttons on the right, wrapped in a flex box */}

        <ChartAction
          keyOfChart={keyOfChart}
          equipmentKpiRef={equipmentKpiRef}
          inspectionKpiRef={inspectionKpiRef}
          ticketKpiRef={ticketKpiRef}
          OrgKpiRef={OrgKpiRef}
          rows={rows}
          selectedEquipmentGroupId={selectedEquipmentGroupId}
        />
      </Grid>

      <Grid container spacing={2} sx={{ marginTop: 2 }}>
        {rows &&
          rows.length > 0 &&
          rows.map((row, rowIndex) => (
            <Grid item xs={12} key={rowIndex}>
              <Grid container spacing={2}>
                {row.sections.map((section, sectionIndex) => (
                  <Grid
                    item
                    xs={12}
                    lg={
                      section.chartId ==
                        "OrganizationInspectorPerfomanceData" ||
                      section.chartId == "OrganizationEquipmentData" ||
                      section.chartId == "OrganizationInspectionCompletionRate"
                        ? 12
                        : 6
                    }
                    md={12}
                    sm={12}
                    key={sectionIndex}
                  >
                    <Box
                      sx={{
                        padding: 2,
                      }}
                    >
                      <Typography variant="h6">{section.heading}</Typography>
                      <Typography variant="subtitle2" color="text.secondary">
                        {section.subheading}
                      </Typography>
                      {section.chartId == "NumberOfTicketsPerEquipment" && (
                        <div className="form-group d-flex  align-items-center">
                          <label htmlFor="equipmentGroupList" className="mr-3">
                            {localization.selectEquipmentGroup}
                          </label>
                          <select
                            className="form-control"
                            id="equipmentGroupList"
                            name="equipmentGroupList"
                            required
                            value={selectedEquipmentGroupId}
                            onChange={(e) => {
                              setSelectedEquipmentGroupId(e.target.value);
                            }}
                          >
                            {equipmentGroupList.map((row, index) => {
                              return (
                                <option key={index} value={row.id}>
                                  {row.bezeichnung}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      )}
                      <Box sx={{ marginTop: 2 }}>
                        {/* Dynamic Chart Rendering */}
                        {chartType === "Bar" && (
                          <div style={{ width: "100%", overflowX: "auto" }}>
                            <DynamicBarChart
                              data={section.chartData.datasets}
                              xLabels={section.chartData.labels}
                              tickSetting={section.chartData.tickSetting}
                              isPercentage={section.chartData.isPercentage}
                              localization={localization}
                              width={Math.max(
                                section.chartData.labels.length * 20,
                                600
                              )} // Set this wider than the container
                              chartBottomMargin={
                                section.chartData.chartBottomMargin
                              }
                            />
                          </div>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
}

function DynamicBarChart({
  data,
  xLabels,
  tickSetting,
  isPercentage,
  localization,
  width,
  chartBottomMargin,
}) {
  return (
    <BarChart
      height={500}
      width={width}
      series={data}
      bottomAxis={{
        tickLabelStyle: { ...tickSetting },
        tickPlacement: "middle",
      }}
      margin={{ bottom: chartBottomMargin }}
      slotProps={{
        legend: {
          direction: "row",
          position: { vertical: "top", horizontal: "middle" },
        },
        noDataOverlay: { message: localization.noDataToDisplayInChart },
      }}
      xAxis={[
        {
          data: xLabels,
          valueFormatter: (code, context) => code,
          scaleType: "band",
          tickInterval: "auto", // you can keep default or give custom
          tickLabelInterval: (value, index) => true,
          tickLabelMinGap: 15,
        },
      ]}
      yAxis={
        isPercentage
          ? [
              {
                valueFormatter: (value) => `${value}%`,
              },
            ]
          : []
      }
    />
  );
}
